import React from "react";
import { Alert, Box, Button, Chip, Typography, Stack } from "@mui/material";
import { CheckCircle, Error, Warning, Info, Close } from "@mui/icons-material";

const STATUS_ICONS = {
  approved: <CheckCircle color="success" fontSize="large" />,
  rejected: <Error color="error" fontSize="large" />,
  declined: <Error color="error" fontSize="large" />,
  pending: <Warning color="warning" fontSize="large" />,
  expired: <Info color="default" fontSize="large" />,
  cancelled: <Info color="default" fontSize="large" />,
};


const STATUS_COLORS = {
  approved: "success",
  rejected: "error",
  declined: "error",
  pending: "warning",
  expired: "info",
  cancelled: "info",
};

const STATUS_LABELS = {
  approved: "تأیید شده",
  rejected: "رد شده",
  declined: "رد شده",
  pending: "در انتظار بررسی",
  expired: "منقضی شده",
  cancelled: "لغو شده",
};

export default function InventoryRequestNotification({
  notification,
  onDismiss,
  onViewDetails,
}) {
  if (!notification) return null;

  const { status, message, quote } = notification;
  const color = STATUS_COLORS[status] || "info";
  const label = STATUS_LABELS[status] || status;

  return (
    <Alert
      severity={color}
      variant="filled"
      sx={{
        mb: 2,
        borderRadius: 2,
        animation: "slideIn 0.3s ease-out",
        "@keyframes slideIn": {
          from: { opacity: 0, transform: "translateY(-10px)" },
          to: { opacity: 1, transform: "translateY(0)" },
        },
      }}
      action={
        <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
          {onViewDetails && (
            <Button
              size="small"
              variant={color === "success" ? "outlined" : "outlined"}
              onClick={onViewDetails}
              sx={{ textTransform: "none", fontWeight: 600 }}
            >
              مشاهده جزئیات
            </Button>
          )}
          <Button
            size="small"
            variant="text"
            onClick={onDismiss}
            sx={{ p: 0.5, minWidth: 36 }}
            aria-label="بستن اعلان"
          >
            <Close fontSize="small" />
          </Button>
        </Box>
      }
    >
      <Stack direction="row" spacing={1.5} alignItems="flex-start" sx={{ flexWrap: "wrap", width: "100%" }}>
        <Box sx={{ flexShrink: 0, mt: 0.5 }}>
          {STATUS_ICONS[status] || <Info color={color} fontSize="large" />}
        </Box>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 0.5, flexWrap: "wrap" }}>
            <Typography variant="subtitle2" fontWeight={700}>
              بروزرسانی وضعیت درخواست موجودی
            </Typography>
            <Chip
              label={label}
              size="small"
              color={color}
              variant={status === "pending" ? "outlined" : "filled"}
            />
          </Stack>
          <Typography variant="body2" sx={{ lineHeight: 1.6 }}>
            {message}
          </Typography>
          {quote && quote.confirmed_unit_price != null && (
            <Box sx={{ mt: 1.5, p: 1.5, borderRadius: 1.5, bgcolor: "background.paper", border: `1px solid ${color}40` }}>
              <Stack direction="row" spacing={2} alignItems="center" sx={{ flexWrap: "wrap" }}>
                <Box>
                  <Typography variant="caption" color="text.secondary">
                    قیمت واحد تأییدشده
                  </Typography>
                  <Typography variant="body2" fontWeight={700} color={color}>
                    {Number(quote.confirmed_unit_price).toLocaleString("fa-IR")} تومان
                  </Typography>
                </Box>
                {quote.confirmed_package_quantity != null && (
                  <Box>
                    <Typography variant="caption" color="text.secondary">
                      تعداد بسته تأییدشده
                    </Typography>
                    <Typography variant="body2" fontWeight={700}>
                      {Number(quote.confirmed_package_quantity).toLocaleString("fa-IR")}
                    </Typography>
                  </Box>
                )}
              </Stack>
            </Box>
          )}
        </Box>
      </Stack>
    </Alert>
  );
}